module.exports = __webpack_public_path__ + "img/t_second_prize.ffbe45f7.png";